<div
  class="text-select-field folder-tree__field"
  #fieldEl
  #folderMenu="appMenu"
  [hasBg]="false"
  [app-menu]="folderTreeRef"
  (click)="onTriggerClick()"
>
  <input
    type="text"
    readonly
    [disabled]="disabled"
    [class.opened]="folderMenu.isOpen"
    [value]="selectedName"
    [placeholder]="placeholder"
  />
  <div class="icon-container">
    <span class="folder-tree__arrow j2-icon-round-arrow" [class.folder-tree__arrow--up]="folderMenu.isOpen"></span>

  </div>
</div>

<ng-template #folderTreeRef>
  <div class="filter-dropdown-container" @fadeReveal>
    <div class="filter-dropdown active newPopup">
      <!-- Оверлей не успадковує ширину тригера — задаємо її явно -->
      <div class="dropdown-wrapper basic card folder-tree__panel" [style.width.px]="panelWidth">
        <!-- Пошук локальний: усе дерево вже на клієнті -->
        <div class="folder-tree__search">
          <input type="text" [(ngModel)]="search" [placeholder]="'search.sidebar.find' | translate" />
        </div>

        <div class="folder-tree__list">
          <app-loader *ngIf="loading" [size]="'input'"></app-loader>

          <div class="folder-tree__empty" *ngIf="!loading && !visibleTree.length">
            {{ 'noRecord' | translate }}
          </div>

          <ng-container *ngTemplateOutlet="branch; context: { $implicit: visibleTree }"></ng-container>
        </div>

        <div class="folder-tree__footer">
          <button type="button" class="btn-template btn-linear" (click)="cancel(); folderMenu.hideMenu()">
            {{ 'button.cancel' | translate }}
          </button>
          <button type="button" class="btn-template btn-blue" (click)="apply(); folderMenu.hideMenu()">
            {{ 'button.apply' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Рекурсивна гілка: бек віддає всі рівні одразу в children -->
<ng-template #branch let-nodes>
  <div class="folder-tree__node" *ngFor="let node of nodes">
    <div
      class="dropdown-item fs-14 folder-tree__row"
      [class.folder-tree__row--selected]="pendingId === node.id"
      [class.folder-tree__row--expanded]="childrenOf(node).length && isExpanded(node)"
      (click)="select(node)"
    >
      <img class="folder-tree__icon" src="/assets/images/table/icon-folder.svg" alt="" />
      <span class="folder-tree__name">{{ node.name }}</span>

      <!-- Папка, у якій документ лежить зараз -->
      <span class="folder-tree__badge" *ngIf="initialId && node.id === initialId">
        {{ 'documents.folder.current' | translate }}
      </span>

      <!-- Стрілка лише там, де є що розгортати -->
      <span
        *ngIf="childrenOf(node).length"
        class="folder-tree__toggle j2-icon-round-arrow"
        [class.folder-tree__toggle--open]="isExpanded(node)"
      ></span>
    </div>

    <div class="folder-tree__children" *ngIf="childrenOf(node).length && isExpanded(node)" @expandCollapsePanel>
      <ng-container *ngTemplateOutlet="branch; context: { $implicit: childrenOf(node) }"></ng-container>
    </div>
  </div>
</ng-template>
